import { render } from "./Expression.vue?vue&type=template&id=0dd75e27&scoped=true"
import script from "./Expression.vue?vue&type=script&lang=js"
export * from "./Expression.vue?vue&type=script&lang=js"

import "./Expression.vue?vue&type=style&index=0&id=0dd75e27&scoped=true&lang=css"

import exportComponent from "D:\\project\\AIWOBU\\admin-love\\lovestory\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dd75e27"]])

export default __exports__